<script>
export default {
  props: {
    setTitle: {
      type: String,
      required: true,
    },
    direction: {
        type: String,
        default: "left",
    }
  },
};
</script>
<template>
  <div class="tooltipContent" :class="`${direction}-arrow`">
    <i :class="['arrow-icon', 'bx', `bxs-${direction}-arrow`]"></i>
    {{ setTitle }}
  </div>
</template>

<style scoped>
.tooltipContent {
  background: var(--black);
  border-radius: 0.3rem;
  color: var(--white);
  padding: 0.2rem 0.3rem;
  font-size: 10px;
  position: relative;
}

.tooltipContent {
  position: absolute;
    transform: translate(0px, calc(-100% - 10px));
}

.tooltipContent .arrow-icon {
    content: "\ee04";
    position: absolute;
    font-size: 12px;
    color: var(--black);
}

.tooltipContent .arrow-icon.bxs-left-arrow {
    left: 0px;
    top: 50%;
    transform: translate(calc(-100% + 4px), -50%);
}

.tooltipContent .arrow-icon.bxs-right-arrow {
    right: 0px;
    top: 50%;
    transform: translate(calc(+100% - 4px), -50%);
}

.tooltipContent .arrow-icon.bxs-up-arrow {
    top: 0px;
    right: 50%;
    transform: translate(50%, calc(-100% + 4px));
}

.tooltipContent .arrow-icon.bxs-up-arrow {
    position: absolute;
    transform: translate(0px, calc(-100% - 10px));
}

.tooltipContent .arrow-icon.bxs-down-arrow {
    bottom: 0px;
    right: 50%;
    transform: translate(50%, calc(100% - 4px));
}

</style>
